<template>
  <div class="w1180 bannerdiv">
    <ul class="navbar fl">
      <!--新加讲师专栏-->
      <li>
        <a href="JavaScript:void(0);">讲师专栏</a>
        <div class="econ">
          <a
            :href="host + item.tid + '/index.html'"
            v-for="(item, index) in teacherList"
            target="_blank"
            style="width: 160px"
            ><span :class="index % 4 == 0 ? '' : 'line1'"></span
            >{{ item.tname }}</a
          >
        </div>
      </li>
      <!--新加讲师专栏-->
      <li v-for="(item, index) in tree" :data-index="index">
        <a
          :class="index == 4 ? 'nob' : ''"
          :href="host + 'lesson/list.html?classification=' + item.id"
          >{{ item.name }}</a
        >
        <div class="econ">
          <a
            :href="host + 'lesson/list.html?method=' + item.id"
            v-for="(item, index) in item.childs"
            ><span :class="index == 0 ? '' : 'line1'"></span>{{ item.name }}</a
          >
          <div class="tj-class" v-if="item.tjList.length > 0">
            <div class="tj-class-tit">
              <span>推荐课程</span
              ><a :href="host + 'lesson/list.html?classification=' + item.id"
                >更多</a
              >
            </div>
            <div class="tj-class-con clearfix">
              <div
                class="tj-class-box clearfix"
                v-for="(_item, _index) in item.tjList"
              >
                <a
                  class="tj-class-img"
                  :href="_item.classDetailUrl"
                  target="_blank"
                  ><img :src="_item.classImageUrl | getImgUrl" alt=""
                /></a>
                <div class="tj-class-txt">
                  <h3>
                    <a :href="_item.classDetailUrl" target="_blank">{{
                      _item.className
                    }}</a>
                  </h3>
                  <a
                    class="tj-teacher"
                    :href="host + _item.teacherId + '/index.html'"
                    target="_blank"
                    >{{ _item.teacherName }}</a
                  >
                  <span class="tj-class-s">{{
                    _item.price ? "￥" + _item.price.toFixed(2) : "&nbsp;&nbsp;"
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div id="bannerclude"></div>
    <!--
        <div class="w1180 bgfff">
        <div class="hotnav clearfix" >
        	<a href="javascript:void(0)" target="_self" class="on" style="cursor: default">热门标签：</a>
        	<a :href="'//caidao.homeway.com.cn/lesson/hottag.html?tag='+item.es" target="_blank" v-for="(item,index) in hotlable">{{item.name}}</a>
        </div>
        </div>
        -->
  </div>
</template>

<script type="text/javascript">
export default {
  name: "Tree",
  data() {
    return {
      tree: [],
      hotlable: [],
      teacherList: [
        /* {
          tid: "4128648",
          tname: "徐小明",
          timg: "https://logotool.hexun.com/88ff3e-150.jpg",
        }, */
        {
          tid: "13798641",
          tname: "史月波高控盘",
          timg: "https://logotool.hexun.com/f18cd2-150.jpg",
        },
        /* {
          tid: "10780870",
          tname: "冯矿伟",
          timg: "https://logotool.hexun.com/c680a4-150.jpg",
        },
        {
          tid: "18858362",
          tname: "东方红陈晨",
          tnameh5: "陈晨",
          timg: "https://logotool.hexun.com/17ac11f-150.jpg",
        },
        {
          tid: '12950098',
          tname: '狐眼看市',
          tnameh5: '狐眼看市',
          timg: '',
        }, */
        {
          tid: "3764690",
          tname: "跑赢大盘的王者",
          tnameh5: "王者",
          timg: "https://logotool.hexun.com/d27139-150.jpg",
        },
        {
          tid: "19444494",
          tname: "财智专栏",
          tnameh5: "财智专栏",
          timg: "",
        },
        {
          tid: "31090159",
          tname: "趋势黄金眼",
          tnameh5: "趋势黄金眼",
          timg: "",
        },
        {
          tid: "25595646",
          tname: "江恩专栏",
          tnameh5: "江恩专栏",
          timg: "",
        },
        {
          tid: "5528397",
          tname: "笑涨专栏",
          tnameh5: "笑涨专栏",
          timg: "",
        },
        /* {
          tid: '29859557',
          tname: '顾勇菁投教',
          timg: 'https://logotool.hexun.com/1e59ec7-150.jpg',
        }, */
        {
          tid: "14702045",
          tname: "趋势侃市",
          tnameh5: "趋势侃市",
          timg: "",
        },
        /* {
          tid: '29826631',
          tname: '映江月专栏',
          tnameh5: '映江月专栏',
          timg: '',
        }, */
        {
          tid: "29394609",
          tname: "秦蠡论股专栏",
          tnameh5: "秦蠡论股专栏",
          timg: "",
        },
        {
          tid: "1037523",
          tname: "首席夏立军",
          timg: "https://logotool.hexun.com/d3d40f-150.jpg",
        },
        /*{
          tid: '31705262',
          tname: '王彪',
          timg: 'https://logotool.hexun.com/1aec8e3-150.jpg',
        },
        {
          tid: '29553064',
          tname: '跟老曹学投资',
          timg: 'https://logotool.hexun.com/1a8f1c2-150.jpg',
        },
        {
          tid: '29834334',
          tname: '丛林相农',
          timg: 'https://logotool.hexun.com/15e3cc7-150.jpg',
        },
        {
          tid: '30077216',
          tname: 'AI量先生',
          timg: 'https://logotool.hexun.com/120f1ca-150.jpg',
        },
        {
          tid: '31259929',
          tname: '杨国荣投教',
          timg: 'https://logotool.hexun.com/119fddc-150.jpg',
        },
        {
          tid: '29607093',
          tname: '胡俍老师',
          timg: 'https://logotool.hexun.com/1b5c4c3-150.jpg',
        },
        {
          tid: '27903739',
          tname: '价值远航张丹',
          timg: 'https://logotool.hexun.com/1fbc6a9-150.jpg',
        },
        {
          tid: '29724472',
          tname: '犀牛投教李雄',
          timg: 'https://logotool.hexun.com/1388fc5-150.jpg',
        },
        {
          tid: '29889835',
          tname: '中证胡腾',
          timg: 'https://logotool.hexun.com/12b15c8-150.jpg',
        }*/
      ], //老师专栏 15个老师
      host:
        "//" +
        (window.location.host.match("test") ? "test" : "") +
        "caidao.homeway.com.cn/",
    };
  },
  filters: {
    getImgUrl: function (_v) {
      return _v && $.trim(_v) != ""
        ? _v
        : "//imgcd.homeway.com.cn/images/default.jpg";
    },
  },
  methods: {
    bindtree: function () {
      // $('#bannerclude').html($('#bclude').html());
      var flag = true;
      var _this = this;
      // cms碎片改为产品运营碎片
      this.getData(this.apilist.incData + "7850_190691142", function (_res) {
        if (_res.code * 1 === 0 && _res.data) {
          $("#bannerclude").html(_res.data);
        }
      });
      /*20180102 優化需求,取消熱門標籤,挪至頭部搜索框處
      _this.getData(_this.apilist.hotlable,function(data){
            if(data.code=='0')
            {
              var arr=[];
              for(var i in data.data.list)
              {
                arr[i]={
                  es:escape(data.data.list[i].title),
                  name:data.data.list[i].title
                }
              }
              _this.hotlable=arr;
            }
        })
        */
      _this.getData(_this.apilist.aggregation, function (data) {
        if (data.code == "0") {
          data.data.forEach(function (item, index) {
            //抛弃 经典理论
            if (index <= 4 && data.data[index].id * 1 !== 6) {
              data.data[index].tjList = []; //添加推荐课程节点
              _this.tree.push(data.data[index]);
            }
          });
          /* for (var i in data.data) {
            if (i > 4 || data.data[i].id * 1 == 6) {
              break; //抛弃 经典理论
            } else {
              data.data[i].tjList = []; //添加推荐课程节点
              _this.tree.push(data.data[i]);
            }
          } */
        }
        _this.$nextTick(function () {
          $(".navbar  li").hover(
            function () {
              // _this.addTuiJian($(this).data('index'));//风控需求,推荐课程下线
              $(this).siblings().removeClass("on");
              $(this).siblings().find(".econ").fadeOut();
              $(this).addClass("on");
              $(this).find(".econ").show();
            },
            function () {
              $(".navbar  li").removeClass("on");
              $(".navbar  li .econ").hide();
            }
          );
        });
      });
    },
    //加载推荐课程
    addTuiJian: function (_index) {
      var _this = this,
        _itemData = _this.tree[_index];
      //请求数据 firstType
      if (
        _itemData &&
        $.isArray(_itemData.tjList) &&
        _itemData.tjList.length <= 0
      ) {
        _this.getData(
          _this.apilist.tjList.replace("{codeType}", _itemData.id),
          function (_data) {
            //console.log('data=',_data);
            if (
              _data &&
              $.isPlainObject(_data.data) &&
              !$.isEmptyObject(_data.data) &&
              $.isArray(_data.data.list) &&
              _data.data.list.length > 0
            ) {
              _this.$set(_itemData, "tjList", _data.data.list);
            }
          }
        );
      }
    },
  },
  mounted() {
    this.bindtree();
  },
};
</script>



// WEBPACK FOOTER //
// tree.vue?1a087aea